"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: tier/cancellation-reason.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftier%2Fcancellation-reason.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancellationReasonToJSON = exports.cancellationReasonFromJSON = exports.CancellationReason = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.tier.proto';
/**
 * Reasons for cancelling a subscription.
 */
var CancellationReason;
(function (CancellationReason) {
    CancellationReason["INVALID_CANCELLATION_REASON"] = "INVALID_CANCELLATION_REASON";
    /**
     * NO_LONGER_NEEDED - No longer needs the service
     */
    CancellationReason["NO_LONGER_NEEDED"] = "NO_LONGER_NEEDED";
    /**
     * DID_NOT_UNDERSTAND_SIGNUP - Didn’t realize what they were signing up for
     */
    CancellationReason["DID_NOT_UNDERSTAND_SIGNUP"] = "DID_NOT_UNDERSTAND_SIGNUP";
    /**
     * ID_VERIFICATION_FAILED - Couldn’t pass ID verification
     */
    CancellationReason["ID_VERIFICATION_FAILED"] = "ID_VERIFICATION_FAILED";
    /**
     * TECHNICAL_ISSUES - Technical issues
     */
    CancellationReason["TECHNICAL_ISSUES"] = "TECHNICAL_ISSUES";
    /**
     * UNSATISFIED_WITH_BENEFITS - Not satisfied with benefits
     */
    CancellationReason["UNSATISFIED_WITH_BENEFITS"] = "UNSATISFIED_WITH_BENEFITS";
    /**
     * INSUFFICIENT_TRAVEL_PERKS - Not enough travel perks
     */
    CancellationReason["INSUFFICIENT_TRAVEL_PERKS"] = "INSUFFICIENT_TRAVEL_PERKS";
    /**
     * COST_RELATED - Cost-related reasons
     */
    CancellationReason["COST_RELATED"] = "COST_RELATED";
    /**
     * CASH_ADVANCE_TOO_LOW - Cash advance amount too low
     */
    CancellationReason["CASH_ADVANCE_TOO_LOW"] = "CASH_ADVANCE_TOO_LOW";
    /**
     * CASH_ADVANCE_UNAVAILABLE - Couldn’t get cash advance
     */
    CancellationReason["CASH_ADVANCE_UNAVAILABLE"] = "CASH_ADVANCE_UNAVAILABLE";
    /**
     * BANK_NOT_SUPPORTED - Bank not supported
     */
    CancellationReason["BANK_NOT_SUPPORTED"] = "BANK_NOT_SUPPORTED";
    /**
     * OTHER - Other reason
     */
    CancellationReason["OTHER"] = "OTHER";
    CancellationReason["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CancellationReason || (exports.CancellationReason = CancellationReason = {}));
function cancellationReasonFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CANCELLATION_REASON':
            return CancellationReason.INVALID_CANCELLATION_REASON;
        case 1:
        case 'NO_LONGER_NEEDED':
            return CancellationReason.NO_LONGER_NEEDED;
        case 2:
        case 'DID_NOT_UNDERSTAND_SIGNUP':
            return CancellationReason.DID_NOT_UNDERSTAND_SIGNUP;
        case 3:
        case 'ID_VERIFICATION_FAILED':
            return CancellationReason.ID_VERIFICATION_FAILED;
        case 4:
        case 'TECHNICAL_ISSUES':
            return CancellationReason.TECHNICAL_ISSUES;
        case 5:
        case 'UNSATISFIED_WITH_BENEFITS':
            return CancellationReason.UNSATISFIED_WITH_BENEFITS;
        case 6:
        case 'INSUFFICIENT_TRAVEL_PERKS':
            return CancellationReason.INSUFFICIENT_TRAVEL_PERKS;
        case 7:
        case 'COST_RELATED':
            return CancellationReason.COST_RELATED;
        case 8:
        case 'CASH_ADVANCE_TOO_LOW':
            return CancellationReason.CASH_ADVANCE_TOO_LOW;
        case 9:
        case 'CASH_ADVANCE_UNAVAILABLE':
            return CancellationReason.CASH_ADVANCE_UNAVAILABLE;
        case 10:
        case 'BANK_NOT_SUPPORTED':
            return CancellationReason.BANK_NOT_SUPPORTED;
        case 99:
        case 'OTHER':
            return CancellationReason.OTHER;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CancellationReason.UNRECOGNIZED;
    }
}
exports.cancellationReasonFromJSON = cancellationReasonFromJSON;
function cancellationReasonToJSON(object) {
    switch (object) {
        case CancellationReason.INVALID_CANCELLATION_REASON:
            return 'INVALID_CANCELLATION_REASON';
        case CancellationReason.NO_LONGER_NEEDED:
            return 'NO_LONGER_NEEDED';
        case CancellationReason.DID_NOT_UNDERSTAND_SIGNUP:
            return 'DID_NOT_UNDERSTAND_SIGNUP';
        case CancellationReason.ID_VERIFICATION_FAILED:
            return 'ID_VERIFICATION_FAILED';
        case CancellationReason.TECHNICAL_ISSUES:
            return 'TECHNICAL_ISSUES';
        case CancellationReason.UNSATISFIED_WITH_BENEFITS:
            return 'UNSATISFIED_WITH_BENEFITS';
        case CancellationReason.INSUFFICIENT_TRAVEL_PERKS:
            return 'INSUFFICIENT_TRAVEL_PERKS';
        case CancellationReason.COST_RELATED:
            return 'COST_RELATED';
        case CancellationReason.CASH_ADVANCE_TOO_LOW:
            return 'CASH_ADVANCE_TOO_LOW';
        case CancellationReason.CASH_ADVANCE_UNAVAILABLE:
            return 'CASH_ADVANCE_UNAVAILABLE';
        case CancellationReason.BANK_NOT_SUPPORTED:
            return 'BANK_NOT_SUPPORTED';
        case CancellationReason.OTHER:
            return 'OTHER';
        case CancellationReason.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.cancellationReasonToJSON = cancellationReasonToJSON;
//# sourceMappingURL=cancellation-reason.js.map